import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';

export const MODALS = {
    MULTI_PICKUP: 'MULTI_PICKUP',
    CSV_UPLOAD: 'CSV_UPLOAD',
    JSON_UPLOAD: 'JSON_UPLOAD',
    PICKUP_INFO: 'PICKUP_INFO',
    CSV_HEADERS: 'CSV_HEADERS',
    INITIAL_DELIVERY: 'INITIAL_DELIVERY',
    SAVE_TEMPLATE: 'SAVE_TEMPLATE',
    ITEMS_VIEW: 'ITEMS_VIEW',
    ITEMS_EDIT: 'ITEMS_EDIT',
    CONTACT: 'CONTACT',
    HAULAWAY: 'HAULAWAY',
    DELIVERY_TYPE_EDIT: 'DELIVERY_TYPE_EDIT',
    AVAILABILITY: 'AVAILABILITY',
    MARKETPLACE: 'MARKETPLACE',
    CREDIT_CARD: 'CREDIT_CARD',
    SUBMIT_VALIDATION_MODAL: 'SUBMIT_VALIDATION_MODAL',
    EDIT_PICKUP_INFO_MODAL: 'EDIT_PICKUP_INFO_MODAL',
    PO_DUPLICATE_CONFIRMATION: 'PO_DUPLICATE_CONFIRMATION',
    PDF_UPLOAD: 'PDF_UPLOAD',
};

export const SHIPMENT_FORM_STATE = {
    CREATE: 'CREATE',
    REVIEW: 'REVIEW',
};

export const SHIPMENT_FORM_TYPES = {
    MANUAL: 'MANUAL',
    CSV: 'CSV',
    JSON: 'JSON',
    PDF: 'PDF',
};

export const PROGRESSION_TYPES = {
    EDIT_PICKUP: 'EDIT_PICKUP',
    PO_CONFIRM: 'PO_CONFIRM',
    PO_CONFIRM_FINALIZE_MARKETPLACE_JOB: 'PO_CONFIRM_FINALIZE_MARKETPLACE_JOB',
    FINALIZE_MARKETPLACE_JOB: 'FINALIZE_MARKETPLACE_JOB',
    PREPARE_MANUAL: 'PREPARE_MANUAL',
    PREPARE_CSV: 'PREPARE_CSV',
    PREPARE_CSV_WITH_SAVE: 'PREPARE_CSV_WITH_SAVE',
    PREPARE_JSON: 'PREPARE_JSON',
    PREPARE_PDF: 'PREPARE_PDF',
};

export const SHIPMENT_FORM_MODAL_PROGRESSION = {
    [PROGRESSION_TYPES.EDIT_ORDER_PICKUP]: [MODALS.PICKUP_INFO],
    [PROGRESSION_TYPES.PO_CONFIRM]: [MODALS.PO_DUPLICATE_CONFIRMATION],
    [PROGRESSION_TYPES.PO_CONFIRM_FINALIZE_MARKETPLACE_JOB]: [MODALS.PO_DUPLICATE_CONFIRMATION, MODALS.MARKETPLACE],
    [PROGRESSION_TYPES.FINALIZE_MARKETPLACE_JOB]: [MODALS.MARKETPLACE],
    [PROGRESSION_TYPES.PREPARE_MANUAL]: [MODALS.PICKUP_INFO],
    [PROGRESSION_TYPES.PREPARE_CSV]: [MODALS.MULTI_PICKUP, MODALS.CSV_UPLOAD, MODALS.PICKUP_INFO, MODALS.CSV_HEADERS],
    [PROGRESSION_TYPES.PREPARE_JSON]: [MODALS.JSON_UPLOAD, MODALS.PICKUP_INFO],
    [PROGRESSION_TYPES.PREPARE_PDF]: [MODALS.PDF_UPLOAD, MODALS.PICKUP_INFO],
    [PROGRESSION_TYPES.PREPARE_CSV_WITH_SAVE]: [
        MODALS.MULTI_PICKUP,
        MODALS.CSV_UPLOAD,
        MODALS.PICKUP_INFO,
        MODALS.CSV_HEADERS,
        MODALS.SAVE_TEMPLATE,
    ],
};

export const EDIT_ORDER_TABS = {
    ORIGIN: 'ORIGIN',
    PICKUP: 'PICKUP',
    CUSTOMER: 'CUSTOMER',
    ORDER_DETAILS: 'ORDER_DETAILS',
    ITEMS: 'ITEMS',
    SERVICES: 'SERVICES',
    HAUL_AWAY: 'HAUL_AWAY',
    ADMIN: 'ADMIN',
    WAREHOUSE: 'WAREHOUSE',
    NOTES: 'NOTES',
    ADMIN_NOTES: 'ADMIN_NOTES',
    NOTIFICATIONS: 'NOTIFICATIONS',
    ADMIN_RATES: 'ADMIN_RATES',
};

export const EDIT_ORDER_TABS_DISPLAY = {
    [EDIT_ORDER_TABS.ORIGIN]: 'Origin',
    [EDIT_ORDER_TABS.PICKUP]: 'Pickup',
    [EDIT_ORDER_TABS.CUSTOMER]: 'Customer',
    [EDIT_ORDER_TABS.ORDER_DETAILS]: 'Details',
    [EDIT_ORDER_TABS.ITEMS]: 'Items',
    [EDIT_ORDER_TABS.SERVICES]: 'Services',
    [EDIT_ORDER_TABS.HAUL_AWAY]: 'Haulaway',
    [EDIT_ORDER_TABS.ADMIN]: 'Admin',
    [EDIT_ORDER_TABS.NOTES]: 'Notes',
    [EDIT_ORDER_TABS.ADMIN_NOTES]: 'Admin Notes',
    [EDIT_ORDER_TABS.WAREHOUSE]: 'Warehousing',
    [EDIT_ORDER_TABS.NOTIFICATIONS]: 'Notifications',
    [EDIT_ORDER_TABS.ADMIN_RATES]: 'Rates',
};

export const EDIT_ORDER_TABS_ICON = {
    [EDIT_ORDER_TABS.ORIGIN]: FactoryOutlinedIcon,
    [EDIT_ORDER_TABS.PICKUP]: LocalShippingOutlinedIcon,
    [EDIT_ORDER_TABS.CUSTOMER]: PersonOutlineOutlinedIcon,
    [EDIT_ORDER_TABS.ORDER_DETAILS]: DescriptionOutlinedIcon,
    [EDIT_ORDER_TABS.ITEMS]: InventoryOutlinedIcon,
    [EDIT_ORDER_TABS.SERVICES]: MiscellaneousServicesOutlinedIcon,
    [EDIT_ORDER_TABS.HAUL_AWAY]: ExitToAppOutlinedIcon,
    [EDIT_ORDER_TABS.ADMIN]: AdminPanelSettingsOutlinedIcon,
    [EDIT_ORDER_TABS.NOTES]: CommentOutlinedIcon,
    [EDIT_ORDER_TABS.ADMIN_NOTES]: CommentOutlinedIcon,
    [EDIT_ORDER_TABS.WAREHOUSE]: WarehouseOutlinedIcon,
    [EDIT_ORDER_TABS.NOTIFICATIONS]: NotificationImportantIcon,
    [EDIT_ORDER_TABS.ADMIN_RATES]: AttachMoneyOutlinedIcon,
};

export const DEFAULT_ITEM = {
    quantity: 1,
    is_return: false,
    is_packaged: true,
};

export const DEFAULT_HAUL_AWAY = {
    quantity: 1,
    is_return: false,
    is_packaged: true,
    return_or_dispose: 'dispose',
};

export const AIRLINE_OPTIONS = ['Accelerated', 'American Airlines', 'Delta', 'FedEx', 'Forward Air', 'UPS'];

export const DISPOSITION_OPTIONS = [
    { label: 'Return to Shipper', value: 'RETURN_TO_SHIPPER' },
    { label: 'Destroy in Field', value: 'DESTROY_IN_FIELD' },
    { label: 'Unknown', value: 'UNKNOWN' },
];

export const DISPOSITION_LABELS = DISPOSITION_OPTIONS.reduce(
    (acc, { value, label }) => ({ ...acc, [value]: label }),
    {}
);

// Non-tab order-error keys surfaced by useOrderErrors / JobDetails.
export const ROUTE_VALIDATION_ERROR = '__route';
export const CARRIER_RATE_ERROR = '__carrier_rate';

// Order types with no delivery leg: no dropoff geocode, no route metrics, no
// haul-away, and no add-on services. Mirrors the backend's consigneeless concept
// (@onward-delivery/core ORDER_TYPE_REQUIREMENTS: consignee false for these types).
export const CONSIGNEELESS_ORDER_TYPES = ['will_call', 'wh_inventory'];

// Order types with no customer at all — the Customer tab is hidden entirely.
// will_call is intentionally excluded: it still captures the pickup person's
// contact on the Customer tab.
export const CUSTOMERLESS_ORDER_TYPES = ['wh_inventory'];

// Which EditOrder tabs an order type hides. Consumed by tab rendering
// (resolveEditOrderTabs), import-flow error projection (reachableImportTabs), and
// the JobDetails byTab projection, so a hidden tab can never carry an error the
// user has no way to reach. ShipmentForm/index.jsx also applies these rules inline
// when building its candidate tab list; resolveEditOrderTabs re-filters that list
// per order.
export const hiddenTabsForOrderType = (orderType) => [
    ...(CUSTOMERLESS_ORDER_TYPES.includes(orderType) ? [EDIT_ORDER_TABS.CUSTOMER] : []),
    ...(CONSIGNEELESS_ORDER_TYPES.includes(orderType) ? [EDIT_ORDER_TABS.SERVICES, EDIT_ORDER_TABS.HAUL_AWAY] : []),
];
